import React, { Component } from "react";

export default class LoadingBlock extends Component {
  render() {
    return <div style={{ minHeight: 500 }}>&nbsp;</div>;
  }
}
